import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationService } from '../../libraries/auth/authorization.service';
import { BasePageComponent } from '../../libraries/base/page/base-page.component';
import { FaqListComponent } from './list/faq-list.component';
import { FaqCreateComponent } from './create/faq-create.component';
import { FaqUpdateComponent } from './update/faq-update.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: BasePageComponent,
        children: [
          {
            path: '',
            component: FaqListComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'faq.read'
            }
          }
        ]
      },
      {
        path: 'create',
        component: BasePageComponent,
        data: {
          breadcrumb: 'Add FAQ'
        },
        children: [
          {
            path: '',
            component: FaqCreateComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'faq.create'
            }
          }
        ]
      },
      {
        path: ':id/update',
        component: BasePageComponent,
        data: {
          breadcrumb: 'Update FAQ'
        },
        children: [
          {
            path: '',
            component: FaqUpdateComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'faq.update'
            }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FaqRoutingModule {}
